<template>
  <div
    class="exam"
    style="-moz-user-select: none"
    v-loading="loading"
    element-loading-text="加载中,请稍后..."
    @keyup="cutQues($event)"
    tabindex="0"
  >
    <el-container>
      <!-- 考试时间安排 -->
      <el-header height="auto">
        <div height="90px" v-show="exam.type != 4">
          <el-row v-if="!disabled">
            <el-col :span="10">考生姓名：{{ mem_name }}</el-col>
            <el-col :span="14">身份证号：{{ idcard }}</el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="10">考生姓名：{{ mem_name }}</el-col>
            <el-col :span="14">身份证号：{{ idcard }}</el-col>
          </el-row>
          <el-row v-if="!disabled">
            <el-col :span="10">考试时长：{{ exam.minutes }}分钟</el-col>
            <el-col :span="14">开放时间：{{ exam.start_time }}</el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="10">得分：{{ result.score }}</el-col>
            <el-col :span="14">答对：{{ result.right_sum }}个</el-col>
          </el-row>
          <el-row v-if="!disabled">
            <el-col :span="10"
              >已用时长：{{ useMinute }}分{{ useSecond }}秒</el-col
            >
            <el-col :span="14">关闭时间：{{ exam.end_time }}</el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="10">错题：{{ result.wrong_sum }}个</el-col>
            <el-col :span="14">漏题：{{ result.leakage_sum }}个</el-col>
          </el-row>
        </div>
      </el-header>

      <el-main>
        <!-- 题型、分数 -->
        <div class="publicDesc">
          <span class="examGrade">
            <strong>{{ i + 1 }}</strong>
            <strong>/{{ ques.length }}</strong>
            <span>
              <span v-show="exam.type != 4" class="quescore" v-if="currentQues"
                >（分值：{{ currentQues.score }}分）</span
              >
            </span>
          </span>
          <span v-show="exam.type != 4" class="score"
            >总分：{{ exam.score }}</span
          >
        </div>
        <el-progress
          :percentage="progress"
          type="line"
          :show-text="false"
        ></el-progress>
        <!--折叠面板  -->
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" title="查看答题卡">
            <el-row>
              <el-col :span="4" v-for="index in card.endPage" :key="index">
                <el-button
                  :type="
                    ques[(card.curPage - 1) * card.pagesize + index - 1]
                      .circleColor
                  "
                  circle
                  @click="
                    toQuestion((card.curPage - 1) * card.pagesize + index - 1)
                  "
                  >{{ (card.curPage - 1) * card.pagesize + index }}</el-button
                >
              </el-col>
            </el-row>
            <el-pagination
              v-show="ques.length > card.pagesize"
              background
              layout="prev, pager, next"
              :total="ques.length"
              :current-page="card.curPage"
              :page-size="card.pagesize"
              @current-change="showCard"
            >
            </el-pagination>
          </el-collapse-item>
        </el-collapse>
        <!-- 题目 -->
        <div class="content" v-if="currentQues">
          <div>
            <strong> {{ i + 1 }}.</strong>
            <span class="queName" v-html="currentQues.name"></span>
            <span class="quetype"> [ {{ currentQues.queType }} ]</span>
          </div>

          <div class="answers" v-if="currentQues.queType != '填空题'">
            <div v-for="(item, index) in currentQues.options" :key="index">
              <div v-if="currentQues.type == 2">
                <p
                  class="option"
                  :class="{ bgGreen: item.greenBg, bgRed: item.redBg }"
                >
                  <el-checkbox
                    @change="
                      val => {
                        fun(val, item)
                      }
                    "
                    v-model="currentQues.is_select"
                    :label="item.id"
                    :disabled="disabled"
                    >{{ code[index] + '.' + item.name }}
                  </el-checkbox>
                </p>
              </div>
              <div v-else>
                <!-- <p class="option">
                  B.计时开始，专注工作，中途不允许做任何与该任务无关的事，直到番茄钟响起，然后在纸上画一个X短暂休息一下<5分钟就行>，每4个番茄时段多休息一会儿。
                </p> -->
                <p
                  class="option"
                  :class="{ bgGreen: item.greenBg, bgRed: item.redBg }"
                >
                  <el-radio
                    @change="
                      val => {
                        fun(val, item)
                      }
                    "
                    v-model="currentQues.is_select"
                    :label="item.id"
                    :disabled="disabled"
                    >{{ code[index] + '.' + item.name }}
                  </el-radio>
                </p>
              </div>
            </div>
          </div>
          <div class="answers" v-else>
            <br />
            <p
              style="padding:5px"
              v-if="currentQues.circleColor"
              :class="[
                currentQues.circleColor == 'danger'
                  ? 'bgRed'
                  : currentQues.circleColor == 'success'
                  ? 'bgGreen'
                  : '',
              ]"
            >
              {{ currentQues.is_select }}
            </p>
            <el-input
              v-else
              v-model="currentQues.is_select"
              type="textarea"
              :rows="2"
              style="width:320px"
            ></el-input>
            <p v-show="answerShow">
              <b style="color:#1676dd">正确答案</b>：<span
                v-for="item in currentQues.options"
                :key="item.id"
                >{{ item.name }}
                <em v-if="index != currentQues.options.length - 1">
                  /
                </em>
              </span>
            </p>
          </div>
          <div class="footer">
            <el-button
              type
              round
              size="small"
              v-show="i > 0"
              @click="preQuestion"
              >上一题</el-button
            >
            <el-button
              type="primary"
              round
              size="small"
              v-show="i < ques.length - 1"
              @click="nextQuestion"
              >下一题</el-button
            >
          </div>
          <div class="submitBtn" v-if="exam.type != 4">
            <el-button
              type="primary"
              v-if="exam.type != 2 && resetBtn"
              @click="resetPaper"
              >重做</el-button
            >
            <el-button
              type="primary"
              :disabled="disabledBtn"
              v-show="submitBtn"
              @click="submit"
              >交卷</el-button
            >
          </div>
          <div v-else class="submitBtn">
            <el-button type="primary" @click="showAnswer(currentQues)"
              >查看答案</el-button
            >
            <el-button type="warning" @click="toClearRecord"
              >清空记录重新答题</el-button
            >
          </div>
          <div v-if="exam.type != 2" class="examMsg">
            如发现试题有误请截图或拍照保存发送给老师，以便更改。
          </div>
          <div v-if="exam.type == 2" class="examMsg">
            如考试途中碰到无法解决的意外情况，请尽量使用手机录像并保存，以联系老师处理。
          </div>
          <el-dialog
            title="提示"
            :visible.sync="dialogSubmit"
            width="400px"
            center
          >
            <p>
              检测到你有未提交的试卷，请立即提交！
            </p>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handlePaper"
                >立即提交</el-button
              >
            </span>
          </el-dialog>
        </div>
      </el-main>
    </el-container>
    <Result
      :result="result"
      :is_repeat="is_repeat"
      :type="exam.type"
      v-if="showResult"
      @checkPaper="checkPaper"
      @resetPaper="resetPaper"
    ></Result>
  </div>
</template>
<script>
import Result from './result'
import $ from 'jquery'
import { shuffle } from '../assets/js/const.js'
import { shuffleType } from '../assets/js/shuffleType.js'
import { isios } from '../components/js/isIos.js'
export default {
  data() {
    return {
      exam: {},
      ques: [],
      count: [],
      index: 0,
      i: 0, //当前题目的索引
      sum: 0, //总分
      code: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
      progress: 0, //进度条
      showResult: false, //展示结果
      submitBtn: true, //控制交卷按钮显示与否
      disabled: false, //选项可选与否
      result: {},
      currentQues: {}, //当前题目
      useMinute: 0,
      useSecond: 0,
      timer: null, //定时器
      endTimer: null,
      obj: {},
      activeNames: [],
      resetBtn: false,
      disabledBtn: false,
      countdown: 0,
      num: 0,
      is_new: 0,
      loading: true,
      card: {
        pagesize: 100,
        curPage: 1,
        endPage: 0,
      },
      is_repeat: 1,
      dialogWarning: false,
      cont: 0,
      warning: 0,
      dialogSubmit: false,
      idcard: '',
      mem_name: '',
      test_id: '',
      answerShow: false,
    }
  },
  components: { Result },

  watch: {
    $route: 'toRefresh',
    ques(val, oldVal) {
      //普通的watch监听

      if (val.length > this.card.pagesize) {
        this.card.endPage = 100
      } else {
        this.card.endPage = val.length
      }
    },
  },

  created() {
    this.init()
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      document.onselectstart = new Function('event.returnValue=false')
    })
    this.idcard = localStorage.getItem('idcard')
    this.mem_name = localStorage.getItem('mem_name')
  },
  mounted() {},

  methods: {
    cutQues(ev) {
      if (ev.keyCode == 37 || ev.keyCode == 38) {
        if (this.i > 0) {
          this.preQuestion()
        }
      }
      if (ev.keyCode == 39 || ev.keyCode == 40) {
        if (this.i < this.ques.length - 1) {
          this.nextQuestion()
        }
      }
    },
    showCard(val) {
      this.card.curPage = val
      if (val * this.card.pagesize > this.ques.length) {
        this.card.endPage = this.ques.length % this.card.pagesize
      } else {
        this.card.endPage = this.card.pagesize
      }
    },
    init() {
      //初始化试卷信息
      let _this = this
      let id = this.$route.params.id
      _this.is_repeat = this.$route.params.is_repeat
      let is_new = this.is_new
      if (_this.Storage.getStorage(id)) {
        //判断本地存储有没有exam和ques如果有则直接赋值，没有则请求接口
        _this.obj = _this.Storage.getStorage(id)
        if (_this.Storage.getStorage('exam' + id)) {
          _this.exam = _this.Storage.getStorage('exam' + id)
        }
        if (_this.Storage.getStorage('ques' + id)) {
          _this.ques = _this.Storage.getStorage('ques' + id)
          _this.currentQues = _this.ques[0]
        }
        if (_this.Storage.getStorage(id).progress) {
          _this.progress = _this.Storage.getStorage(id).progress
        }
        if (!isNaN(_this.Storage.getStorage(id).minute)) {
          _this.useMinute = _this.Storage.getStorage(id).minute
        } else {
          _this.useMinute = 0
        }
        if (_this.Storage.getStorage(id).second) {
          _this.useSecond = _this.Storage.getStorage(id).second
        } else {
          _this.useSecond = 0
        }

        if (_this.exam.type != 4) {
          _this.useTime()
        }
        _this.loading = false
      } else {
        _this.obj = {}
        _this.useMinute = 0
        _this.useSecond = 0
        _this.$http
          .get(process.env.VUE_APP_API_URL + 'pen/' + id + '/' + is_new)
          .then(function(data) {
            _this.loading = false
            if (data.data.code == 403) {
              _this.$message.error(data.data.msg)
              _this.$router.push({ name: 'entrance' })
            } else {
              if (data.data.type == 2) {
                //考试卷已考过
                let id = _this.$route.params.id
                _this.$router.push({ name: 'entrance', params: { id: id } })
              } else {
                //没考过的
                _this.exam = data.data.data
                _this.Storage.setStorage('exam' + id, _this.exam)
                _this.obj.exam = _this.exam
                let ques = data.data.data.question
                ques.forEach(item => {
                  if (item.type == 2) {
                    item.is_select = []
                  } else {
                    item.is_select = ''
                  }
                  switch (item.type) {
                    case 1:
                      item.queType = '单选题'
                      break
                    case 2:
                      item.queType = '多选题'
                      break
                    case 3:
                      item.queType = '判断题'
                      break
                    case 4:
                      item.queType = '填空题'
                      break
                  }
                })
                if (data.data.code == 200) {
                  //去考试
                  _this.disabled = false
                  if (_this.exam.is_random) {
                    //判断题目是否随机
                    ques = shuffleType(ques)
                  }
                  if (_this.exam.is_option_random) {
                    //判断题目选项是否随机
                    ques.forEach(item => {
                      item.options = shuffle(item.options)
                    })
                  }
                  _this.ques = JSON.parse(JSON.stringify(ques))
                  _this.Storage.setStorage('ques' + id, ques)
                  // _this.Storage.getStorage('ques' + id)
                  _this.obj.ques = _this.ques
                  _this.currentQues = _this.ques[0]
                  _this.useTime()
                } else if (data.data.code == 201) {
                  //做过的测试卷，测验卷、个人卷，显示每道考题的作答情况。
                  _this.resetBtn = data.data.data.is_repeat == 1 ? true : false //显示重做按钮
                  if (_this.Storage.getStorage('ques' + id)) {
                    _this.ques = _this.Storage.getStorage('ques' + id)
                  } else {
                    _this.ques = JSON.parse(JSON.stringify(ques))
                  }
                  _this.currentQues = _this.ques[0]
                  _this.i = 0
                  _this.showResult = false
                  _this.progress = 100
                  _this.submitBtn = false
                  _this.disabled = true
                  _this.result = data.data.results //赋值给结果
                  let exams = _this.ques

                  if (data.data.type !== 2 || data.data.type != 4) {
                    ques.forEach(element => {
                      exams.forEach(exam => {
                        if (exam.id == element.id) {
                          exam.seleted = element.seleted
                          exam.is_right = element.is_right
                        }
                      })
                    })
                    let select = false

                    exams.forEach(exam => {
                      if (exam.type == 4) {
                        _this.result.qusetion.forEach(item => {
                          if (item.question_id == exam.id) {
                            exam.is_select = item.seleted
                            exam.seleted = item.seleted
                          }
                        })
                      } else {
                        exam.is_select = exam.seleted //勾选用户所选选项
                      }
                      let options = exam.options //拿到每道题的选项
                      if (_this.exam.is_show_answer) {
                        _this.answerShow = true
                        options.forEach(option => {
                          //标记所有题目的正确选项
                          if (option.is_right) {
                            option.bgColor = true
                            option.greenBg = true
                          }
                        })
                      }

                      if (exam.type == 2 && exam.seleted[0] != '') {
                        select = true
                      } else if (exam.type != 2 && exam.seleted != '') {
                        select = true
                      }
                      if (!exam.is_right && select) {
                        //如果做错了题
                        exam.circleColor = 'danger' //根据得分情况以及选择与否改变答题卡的颜色
                        options.forEach(option => {
                          //如果做错了题，将错题标记
                          if (exam.type == 1 || exam.type == 3) {
                            if (option.id == exam.seleted) {
                              option.bgColor = true
                              option.redBg = true
                            }
                          } else if (exam.type == 2) {
                            exam.seleted.forEach(i => {
                              if (!option.is_right && option.id == i) {
                                //如果选项是错的，但是选择的选择与该选项的id一样，那么标红
                                option.bgColor = true
                                option.redBg = true
                              }
                            })
                          }
                        })
                      } else if (exam.is_right) {
                        exam.circleColor = 'success'
                      }
                    })
                  }
                } else if (data.data.code == 202) {
                  //顺序答题
                  if (_this.exam.is_random) {
                    //判断题目是否随机
                    ques = shuffle(ques)
                  }
                  if (_this.exam.is_option_random) {
                    //判断题目选项是否随机
                    ques.forEach(item => {
                      item.options = shuffle(item.options)
                    })
                  }
                  _this.ques = JSON.parse(JSON.stringify(ques))
                  _this.Storage.setStorage('ques' + id, _this.ques)
                  _this.obj.ques = _this.ques
                  _this.currentQues = _this.ques[0]
                  //_this.load();
                } else {
                  _this.$message.error(data.data.msg)
                }
              }
            }
          })
          .catch(function(error) {
            _this.loading = false
            _this.$message.error({ message: '网络错误,请刷新界面重试' })
            console.log(error)
            return
          })
      }
    },

    useTime() {
      //已用时间
      let _this = this,
        id = this.$route.params.id
      clearInterval(this.Storage.getStorage('timer'))
      function changeTime() {
        if (_this.useMinute != _this.exam.minutes) {
          if (_this.useSecond == 59) {
            _this.useMinute++
            _this.useSecond = 0
          } else {
            _this.useSecond++
          }
        } else {
          clearInterval(_this.timer)
          _this.timer = null
          _this.submit()
        }
        _this.obj.minute = _this.useMinute
        _this.obj.second = _this.useSecond

        _this.Storage.setStorage(id, _this.obj)
      }

      _this.localDate()
      _this.timer = setInterval(changeTime, 1000)
      _this.Storage.setStorage('timer', _this.timer)
    },
    localDate() {
      let _this = this,
        id = _this.$route.params.id
      if (_this.exam.type == 5) {
        id = _this.exam.id
      }
      clearInterval(_this.Storage.getStorage('endTimer')) //清除上一次的定时器
      _this.$http
        .post(process.env.VUE_APP_API_URL + 'getTime', { id: id })
        .then(function(data) {
          // let cha = data.data.time - parseInt(new Date().getTime() / 1000)
          let nowtime = parseInt(new Date().getTime() / 1000)
          let time_start =
            nowtime -
            new Date(data.data.res.created_at.replace(/-/g, '/')).getTime() /
              1000
          _this.obj.exam_time = Number(_this.exam.minutes) + 20
          _this.obj.start_time =
            new Date(data.data.res.created_at.replace(/-/g, '/')).getTime() /
            1000
          _this.Storage.setStorage(id, _this.obj)
          _this.s_to_hs(time_start)

          let falg = false
          _this.endTimer = setInterval(function() {
            if (_this.exam.minutes - _this.useMinute <= 0) {
              _this.disabled = true
            }
            if (
              _this.exam.minutes - _this.useMinute <= 10 &&
              falg == false &&
              _this.exam.type == 2
            ) {
              falg = true
              _this.$message({
                duration: 5000,
                message:
                  '本场考试还剩10分钟，请考生请考生抓紧时间答题或审核试卷，到时系统将自动收卷。',
                type: 'warning',
              })
            }
            // let time = data.data.endtime - nowtime - cha
            let time = _this.exam.minutes - _this.useMinute
            if (time > 0) {
              time--
            } else {
              clearInterval(_this.endTimer)
              _this.endTimer = null
              _this.submit()
            }
          }, 1000)
          _this.Storage.setStorage('endTimer', _this.endTimer)
        })
        .catch(function(error) {
          console.log(error)
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    s_to_hs(s) {
      //计算分钟
      //算法：将秒数除以60，然后下舍入，既得到分钟数
      var h
      h = Math.floor(s / 60)
      //计算秒
      //算法：取得秒%60的余数，既得到秒数
      s = s % 60
      //将变量转换为字符串
      h += ''
      s += ''
      h = h.length == 1 ? h : h
      s = s.length == 1 ? s : s
      if (h == -1) {
        h = 0
      }
      if (s == -1) {
        s = 0
      }

      this.useMinute = h
      this.useSecond = s
    },
    fun(val, option) {
      let question = this.currentQues,
        exam = this.ques,
        type = question.type,
        i = 0

      if (type == 1 || type == 3) {
        //默认单选判断一经触发该方法状态即为选中
        question.check = true
        question.circleColor = 'primary'
      } else {
        if (question.is_select.length > 0) {
          question.check = true
          question.circleColor = 'primary' //通过判断value来判断是否选择了该题目
        } else {
          question.check = false
          question.circleColor = 'default'
        }
      }
      exam.forEach(item => {
        if (item.check) {
          i++
        }
      })
      this.progress = (i / exam.length) * 100
      let id = this.$route.params.id
      // this.Storage.setStorage('ques'+id,this.ques);
      // this.Storage.setStorage('progress'+id,this.progress);
      this.obj.ques = this.ques
      this.obj.progress = this.progress
      this.Storage.setStorage(id, this.obj.ques)
    },
    preQuestion() {
      //上一题
      this.i -= 1
      this.currentQues = this.ques[this.i]
    },
    nextQuestion() {
      //下一题
      this.i += 1
      this.currentQues = this.ques[this.i]
    },
    toQuestion(i) {
      //跳转到某一题
      this.i = i
      this.activeNames = []
      this.currentQues = this.ques[this.i]
    },
    submit() {
      //提交试卷
      let _this = this
      this.disabledBtn = true
      let questions = _this.ques,
        submits = true //记录是否答完所有题目
      questions.forEach(ques => {
        if (!ques.check) {
          submits = false
          return
        }
      })
      if (_this.endTimer) {
        //如果时间没到
        if (!submits && _this.timer) {
          _this
            .$confirm(
              '您还有题目没有作答，是否依旧选择交卷？如继续答题，可点击答题卡查看未做题目。',
              {
                confirmButtonText: '交卷',
                cancelButtonText: '返回',
                closeOnClickModal: false,
              }
            )
            .then(() => {
              _this.loading = true
              _this.handlePaperData(_this.ques)
            })
            .catch(() => {
              _this.loading = false
              _this.disabledBtn = false
              _this.$message.warning('已取消，点击答题卡可查看未做题目！')
            })
        }
        if (submits && _this.timer) {
          _this
            .$confirm('您确定要交卷吗?提交后无法更改!', {
              confirmButtonText: '交卷',
              cancelButtonText: '取消',
              closeOnClickModal: false,
            })
            .then(() => {
              _this.loading = true
              _this.handlePaperData(_this.ques)
            })
            .catch(() => {
              _this.loading = false
              _this.disabledBtn = false
              _this.$message.warning('已取消，点击答题卡可查看未做题目！')
            })
        }
      } else {
        //时间到了，直接交卷
        _this.loading = true
        _this.$message.warning('考试时间到！')
        _this.handlePaperData(_this.ques)
      }
    },
    handlePaper() {
      let data = this.Storage.getStorage(this.exam.pid)
      this.handlePaperData(data)
    },
    handlePaperData(data) {
      let option = [],
        ques = JSON.parse(JSON.stringify(data))
      ques.forEach(item => {
        option.push({
          id: item.id,
          type: item.type,
          options: item.is_select,
        })

        item.options = JSON.stringify(item.options)
      })
      let exam = JSON.parse(JSON.stringify(this.exam))
      exam.usedTime = this.useMinute * 60 + this.useSecond
      exam.question = JSON.stringify(option)
      let _this = this,
        id = this.$route.params.id
      this.$http
        .post(process.env.VUE_APP_API_URL + 'paper', exam)
        .then(function(data) {
          _this.disabledBtn = false
          _this.loading = false
          if (data.data.code == 200) {
            clearInterval(_this.timer)
            clearInterval(_this.endTimer)
            _this.timer = null
            _this.endTimer = null
            _this.Storage.delStorage(id)
            _this.Storage.delStorage('timer')
            _this.Storage.delStorage('endTimer')
            _this.dialogSubmit = false
            if (data.data.type == 2) {
              //如果是考试卷
              _this
                .$confirm('考试结束，成绩请咨询主考学校！', {
                  confirmButtonText: '确定',
                  closeOnClickModal: false,
                  showClose: false,
                  showCancelButton: false,
                })
                .then(() => {
                  let id = _this.$route.params.id
                  if (_this.exam.skip_url) {
                    //考试结束跳转满意度调查
                    _this.$router.push({
                      name: 'entrance',
                      params: { id: id },
                    })
                    window.open(_this.exam.skip_url)
                  } else {
                    _this.$router.push({ name: 'entrance', params: { id: id } })
                  }
                })
            } else {
              //如果是测试卷显示考试结果
              _this.result = data.data.data
              _this.showResult = true //显示结果页
            }
          } else {
            _this.$message.error(data.data.msg)
            _this.$router.push({ name: 'entrance' })
          }
        })
        .catch(function(error) {
          _this.disabledBtn = false
          _this.loading = false
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },

    checkPaper() {
      this.showResult = false
      this.is_new = 0
      this.init()
    },
    resetPaper(event) {
      let _this = this
      // if (_this.exam.type == 1) {
      //   //测验卷
      //   if (event >= 80 || _this.result.score >= 80) {
      //     _this.$message.error({ message: '你已获得优良成绩，无需重做！' })
      //     // _this.$message.error({ message: '你的考试成绩已合格，无需重做！' })
      //     return false
      //   }
      // }

      let id = _this.exam.id
      if (_this.exam.type == 5) {
        id = _this.exam.pid
      }
      _this.is_new = 1
      _this.showResult = false
      _this.$http
        .post(process.env.VUE_APP_API_URL + 'delRes', { id: id })
        .then(function(data) {
          _this.Storage.delStorage(id)
          _this.Storage.delStorage('ques' + id)
          _this.Storage.delStorage('exam' + id)
          _this.$router.push({ name: 'entrance', params: { id: id } })
          _this.init()
        })
        .catch(function(error) {
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    toRefresh() {
      window.location.href('')
    },
    showAnswer(que) {
      // this.$message.error('error')
      this.currentQues.showParsing = que.parsing != '' ? true : false
      let options = que.options //拿到每道题的可选项
      let arr = []

      options.forEach(option => {
        //标记所有题目的正确选项
        option.greenBg = false
        option.redBg = false
        if (option.is_right) {
          option.bgColor = true
          option.greenBg = true
          arr.push(option.id)
        }
      })

      let select = false
      if (que.type == 2 && que.is_select.length != 0) {
        select = true
        let len = que.is_select.length
        if (len == arr.length) {
          arr.forEach(i => {
            if (que.is_select.indexof(i) != -1) {
              que.is_right = true
            } else {
              que.is_right = false
              return
            }
          })
        } else {
          que.is_right = false
        }
      } else if (que.type != 2 && que.is_select != '') {
        select = true
        if (arr[0] == que.is_select) {
          que.is_right = true
        } else {
          que.is_right = false
        }
      }

      if (!que.is_right && select) {
        //如果做错了题
        que.circleColor = 'danger' //根据得分情况以及选择与否改变答题卡的颜色

        options.forEach(option => {
          //如果做错了题，将错题标记
          if (que.type == 1 || que.type == 3) {
            if (option.id == que.is_select) {
              option.bgColor = true
              option.redBg = true
            }
          } else if (que.type == 2) {
            que.is_select.forEach(i => {
              if (!option.is_right && option.id == i) {
                //如果选项是错的，但是选择的选择与该选项的id一样，那么标红
                option.bgColor = true
                option.redBg = true
              }
            })
          }
        })
      } else if (que.is_right) {
        que.circleColor = 'success'
      }
      this.Storage.setStorage(this.exam.id, this.obj)
      this.$forceUpdate()
    },
    toClearRecord(paper_id) {
      let _this = this
      this.$confirm('此操作将清除所有答题记录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      })
        .then(() => {
          _this.progress = 0
          _this.i = 0
          _this.Storage.delStorage(this.exam.id)
          _this.count = []
          _this.init()
        })
        .catch(() => {
          _this.$message.warning('已取消，可继续答题！')
        })
    },
    load() {
      this.$nextTick(() => {
        let n = Math.floor(this.ques.length / 60) - 1
        if (this.index < n) {
          this.count.push(
            ...this.ques.slice(this.index * 60, (this.index + 1) * 60)
          )
          this.index++
        } else if (this.index == n) {
          this.count.push(...this.ques.slice(this.index * 60))
          this.index++
        } else {
          return
        }
      })
    },
  },
}
</script>
<style lang="less" scope>
.el-collapse-item__header {
  line-height: 40px !important;
  height: 40px !important;
  display: block !important;
  text-align: center;
  color: #1890ff !important;
}
.el-message-box {
  width: 80% !important;
}
.exam {
  max-width: 1000px !important;
  margin: 0 auto;
  // background-image:url('../assets/bg.png');
  background-image: linear-gradient(#096dd9, #83bdf9);
  padding-bottom: 20px;
  background-size: 100% 100%;
  font-size: 14px;
  position: relative;
  overflow-y: atuo;
  .el-header {
    padding: 10px;
    .el-row {
      text-align: left;
      padding: 5px;
      color: #fff;
      font-size: 13px;
    }
  }
  .el-main {
    border-radius: 8px;
    background: #fff;
    margin: 0 10px;
    .publicDesc {
      // justify-content: space-between;
      height: 30px;
      line-height: 30px;

      .score {
        margin-right: 30px;
      }
      .examGrade {
        padding-left: 10px;
      }
      .examGrade > strong {
        font-size: 16px;
      }
    }
    .content {
      padding-top: 14px;
      width: 100%;
      box-sizing: border-box;
    }
    .el-collapse {
      border: none !important;
      .el-col {
        padding: 3px;
        .el-button {
          width: 40px;
          height: 40px;
          text-align: center;
          padding: 5px;
        }
      }
    }
    .radioAnswer {
      padding: 5px;
    }
    .answers {
      min-height: 280px;

      .option {
        margin: 0;
        padding: 8px 0;
        display: flex;
        overflow: hidden;
        word-break: break-all;
        overflow-wrap: break-word;
        font-size: 17px;
        line-height: 17px;
      }
      .el-radio {
        margin-left: 10px;
      }
    }
    .footer {
      text-align: right;
      .el-button + .el-button {
        margin-left: 50px;
      }
    }
    .submitBtn {
      text-align: center;
      padding-top: 40px;
      padding-bottom: 10px;
    }
    .examMsg {
      color: rgb(146, 139, 139);
    }
  }
}
// 未选中样式

.bgRed {
  background-color: #fff1f2;
  color: #f93a4e;
}
.bgGreen {
  background-color: #edfffd !important;
  color: #1ca194 !important;
}
.el-radio__input.is-disabled + span.el-radio__label,
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666 !important;
}
.bgGreen .el-radio__input.is-disabled + span.el-radio__label,
.bgGreen .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1ca194 !important;
}
.bgRed .el-radio__input.is-disabled + span.el-radio__label,
.bgRed .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #f93a4e !important;
}
.bgGreen .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
.bgRed .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
.bgRed .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after,
.bgGreen .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  background-color: #000;
}
.el-radio {
  margin-right: 0 !important;
  .el-radio__inner {
    border-color: #999;
  }
}
.el-checkbox {
  .el-checkbox__inner {
    border-color: #999;
  }
}
.el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner,
.el-checkbox__input.is-disabled .el-checkbox__inner {
  border-color: #999 !important;
}
.el-button--danger {
  background-color: #f93a4e !important;
}
.el-button--success {
  background-color: #1ca194 !important;
}
.el-radio__label,
.el-checkbox__label {
  font-size: 16px !important;
  white-space: normal;
  margin-right: 10px;
}

.el-collapse-item__header {
  font-size: 16px !important;
}
.queName {
  font-size: 18px;
}
.queName p {
  display: inline;
}
.quetype {
  color: red;
  font-size: 16px;
}

@media screen and (min-device-width: 600px) {
  .el-message-box {
    width: 400px !important;
  }
  .submitBtn {
    text-align: center;
  }
}
</style>
